import React, { useEffect, useState } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import Users from '../../Users';
import Categories from '../../Categories';
import KentuckyCodes from '../../KentuckyCodes';
import DateRange from '../../DateRange';
import Archived from '../../Archived';
import { Link, useNavigate } from 'react-router';
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Spinner } from 'reactstrap';
import useFilter from '../../../hooks/useFilter';
import useNavBar from '../../../hooks/useNavBar';

export default function KentuckyDetailReportForm() {
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const users = Users();
    const categories = Categories();
    const kentuckyCodes = KentuckyCodes();
    const dateRange = DateRange();
    const archived = Archived();

    const { filter, setFilter } = useFilter();
    const { loading, setLoading } = useNavBar();

    const headers =
        [
            "Full Name",
            "Type",
            "Kentucky Code",
            "Activity",
            "Course UID",
            "Training Hours",
            "Completion Date",
            "Start Time",
            "End Time",
            "Status",
            "Other Training Codes",
            "Score",
            "Location",
            "Description",
            "Internal Instructors",
            "External Instructors",
            "Department",
            "Personnel ID",
            "Rank"
        ];

    useEffect(() => {
        if (!users.loading && !kentuckyCodes.loading && !dateRange.loading && !archived.loading) {
            setLoading(false);
        }

        let adjustedHeaders = [
            ...headers,
            ...(users.includeInactiveUsers ? ["User Status"] : []), // end of user fields, which is end of array
            ...(archived.includeArchivedCompletions ? ["Enrollment Status", "Archived Date"] : []) // end of all fields
        ];

        setFilter({
            users: users.selectedUsers.map(user => user.value),
            groups: users.selectedGroups.map(group => group.value),
            categories: categories.selectedCategories,
            selectAllCategories: categories.selectAll,
            kentuckyCodes: kentuckyCodes.selected.map(code => code.value),
            headers: adjustedHeaders,
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            includeArchivedCompletions: archived.includeArchivedCompletions,
            hasArchivedCompletions: archived.hasArchivedCompletions,

            selectAllUsers: users.selectAll,
            formUsers: users.users,
            includeInactiveUsers: users.includeInactiveUsers,
            formGroups: users.groups,
            formCategories: categories.categories,
            formCategoryIds: categories.categoryIds,
            formExpandedCategories: categories.expandedCategories,
            formCodes: kentuckyCodes.kentuckyCodes
        });

        kentuckyCodes.setAllowNullKentuckyCodesOption(false);
    }, [users.loading,
    users.selectAll,
    users.selectedUsers,
    users.users,
    users.selectedGroups,
    users.groups,
    users.includeInactiveUsers,
        categories.selectAll,
        categories.categories,
        categories.selectedCategories,
        categories.categoryIds,
        categories.expandedCategories,
    kentuckyCodes.loading,
    kentuckyCodes.selected,
    kentuckyCodes.kentuckyCodes,
    kentuckyCodes.setAllowNullKentuckyCodesOption,
    dateRange.loading,
    dateRange.startDate,
        dateRange.endDate,
        archived.includeArchivedCompletions,
        archived.hasArchivedCompletions
    ]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const sendfilter = (
            (
                { users, groups, categories, selectAllCategories, kentuckyCodes, headers, startDate, endDate, includeArchivedCompletions, hasArchivedCompletions }) =>
                ({ users, groups, categories, selectAllCategories, kentuckyCodes, headers, startDate, endDate, includeArchivedCompletions, hasArchivedCompletions })
        )(filter);

        try {
            await axiosPrivate.post('api/reports/kentuckydetail', sendfilter);
            navigate('/reports');
        }
        catch (err) {
            console.log(err);
        }
    }

    return (
        loading ? <Spinner variant="primary" animation="border" role="status" className='custom-spinner' /> :
            <Container>
                <Col>
                    <FormGroup>
                        <Card>
                            <CardBody>
                                <FormGroup>
                                    {users.render}
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </FormGroup>
                    <FormGroup>
                        <Card>
                            <CardBody>
                                <FormGroup>
                                    {categories.render}
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </FormGroup>
                    <FormGroup>
                        <Card>
                            <CardBody>
                                <FormGroup>
                                    {kentuckyCodes.render}
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </FormGroup>
                    <FormGroup>
                        <Card>
                            <CardBody>
                                <FormGroup>
                                    {dateRange.render}
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </FormGroup>
                    {
                        archived.hasArchivedCompletions ?
                            <FormGroup>
                                <Card>
                                    <CardBody>
                                        <FormGroup>
                                            {archived.render}
                                        </FormGroup>
                                    </CardBody>
                                </Card>
                            </FormGroup>
                            :
                            null
                    }                </Col>
                <footer>
                    <Form onSubmit={handleSubmit}>
                        <Button color="primary">Generate Report</Button>
                        <Link to="/">
                            <Button className='btn-danger'>Back</Button>
                        </Link>
                    </Form>
                </footer>
            </Container>
    );
}